import AddBank from './add-bank-progressive';

export default AddBank;
